module.exports = __webpack_public_path__ + "static/media/marriageArticle1.42c09b11.jpg";